import { render, staticRenderFns } from "./modifySiderBar.vue?vue&type=template&id=456dcc8c&scoped=true"
import script from "./modifySiderBar.vue?vue&type=script&lang=js"
export * from "./modifySiderBar.vue?vue&type=script&lang=js"
import style0 from "./modifySiderBar.vue?vue&type=style&index=0&id=456dcc8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456dcc8c",
  null
  
)

export default component.exports